import { render, staticRenderFns } from "./ConsumptionDataExchangeVarysSW.vue?vue&type=template&id=2cf6afca&lang=pug&"
import script from "./ConsumptionDataExchangeVarysSW.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionDataExchangeVarysSW.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports